function getHomePageTitle(translate, surveyIsActive, onRevisionPhase, isSurveyFinished) {
  const translationKeyPrefix = "benchmarking.data-collection-page";
  let title = null;

  if (surveyIsActive || onRevisionPhase || isSurveyFinished) {
    title = translate("benchmarking.landing-page.title");
    return title;
  } else {
    title = translate(`${translationKeyPrefix}.inactive.title`);
    return title;
  }
}

export default getHomePageTitle;
